import { combineEpics } from 'redux-observable';

import { openAlertEpic, errorHandleEpic } from './alert';
import {
	addProductIntoCartEpic,
	addAdditionalIntoCartEpic,
	calculateTotalPriceForPromotionEpics,
} from './cart';

export default combineEpics(
	openAlertEpic,
	addProductIntoCartEpic,
	addAdditionalIntoCartEpic,
	calculateTotalPriceForPromotionEpics,
	errorHandleEpic,
);
